var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Link } from 'react-router';
import cx from 'classnames';
import styles from './Button.css';
export default function Button(_a) {
    var { className, children, href, link = false, external, primary, secondary } = _a, props = __rest(_a, ["className", "children", "href", "link", "external", "primary", "secondary"]);
    const classnames = cx({
        [styles['btn']]: !link
    }, className, {
        [styles['btn-primary']]: primary,
        [styles['btn-secondary']]: secondary,
        [styles['btn-link']]: link
    });
    if (!href) {
        return (<button className={classnames} {...props}>
				{children}
			</button>);
    }
    if (external) {
        return (<a className={classnames} href={href} {...props}>
				{children}
			</a>);
    }
    return (<Link className={classnames} to={href} {...props}>
			{children}
		</Link>);
}
